import { API } from "../api/axios";
const END_POINT = "/classes";
const END_POINT_CLASS = "/class";
const END_POINT_TEACHER= "/teachers";
const END_POINT_STUDENT= "/students";
const END_POINT_FILTER = "/homeworks-filter";

class ClasseService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
  
    getFilter(params) {
        return API.get(END_POINT_FILTER, params);
    }
    get(id) {
        return API.get(`${END_POINT_CLASS}${END_POINT}/${id}`);
    }
    getTeachers(id,params) {
        return API.get(`${END_POINT_TEACHER}${END_POINT_CLASS}/${id}`,params);
    }
    getStudents(id,params) {
        return API.get(`${END_POINT_STUDENT}${END_POINT_CLASS}/${id}`,params);
    }
    delete(id) {
        return API.delete(`${END_POINT_CLASS}/${id}`);
    }
    create(data) {
        return API.post(END_POINT_CLASS, data);
    }
    update(id, data) {
        return API.post(`${END_POINT_CLASS}/${id}`, data);
    }
}

export default new ClasseService();
